// Ticket-Status ändern – eine Stelle für Ticketseite und Dienstleister-Bereich:
// Update, Historie (status_change) und Benachrichtigung des Zuständigen.

import { supabase } from '../supabase/client';
import { createNotification } from '../notifications/createNotification';

export interface TicketStatusQuelle {
  id: string;
  ticket_nummer: string | null;
  status: string | null;
  zustaendig_id?: string | null;
}

/** Abschluss (erledigt/geschlossen) braucht einen Grund – wie im Abschluss-Dialog der Ticketseite. */
export const brauchtAbschlussGrund = (status: string) => status === 'erledigt' || status === 'geschlossen';

export async function setzeTicketStatus(
  ticket: TicketStatusQuelle, neuerStatus: string, opts: { benutzerId: string | null; grund?: string; zusatz?: Record<string, string | null> },
): Promise<void> {
  const updates: Record<string, string | null> = { status: neuerStatus, ...(opts.zusatz ?? {}) };
  if (opts.grund) updates.abschluss_grund = opts.grund;
  const { error } = await supabase.from('tickets').update(updates).eq('id', ticket.id);
  if (error) throw new Error(error.message);

  await supabase.from('ticket_historie').insert({
    ticket_id: ticket.id, benutzer_id: opts.benutzerId, aktion: 'status_change', alter_wert: ticket.status, neuer_wert: neuerStatus,
  });

  if (ticket.zustaendig_id && ticket.zustaendig_id !== opts.benutzerId) {
    await createNotification({
      benutzerId: ticket.zustaendig_id, modul: 'tickets', typ: 'status_change', nachricht: `Ticket ${ticket.ticket_nummer} Status: ${neuerStatus}`,
      referenzId: ticket.id, referenzTyp: 'ticket', linkPfad: '/admin/tickets', erstelltVon: opts.benutzerId ?? undefined,
    });
  }
}
